const jalaliToGregorian = (jy, jm, jd) => {
  const gDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  const jDaysInMonth = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

  jy = Number.parseInt(jy, 10);
  jm = Number.parseInt(jm, 10);
  jd = Number.parseInt(jd, 10);

  let gy = 1600;
  let jDayNo =
    365 * (jy - 979) + Math.floor((jy - 979) / 33) * 8 + Math.floor((((jy - 979) % 33) + 3) / 4);

  for (let i = 0; i < jm - 1; i++) {
    jDayNo += jDaysInMonth[i];
  }

  jDayNo += jd - 1;

  let gDayNo = jDayNo + 79;

  gy += 400 * Math.floor(gDayNo / 146097);
  gDayNo %= 146097;

  let leap = true;

  if (gDayNo >= 36525) {
    gDayNo--;

    gy += 100 * Math.floor(gDayNo / 36524);
    gDayNo %= 36524;

    if (gDayNo >= 365) {
      gDayNo++;
    } else {
      leap = false;
    }
  }

  gy += 4 * Math.floor(gDayNo / 1461);
  gDayNo %= 1461;

  if (gDayNo >= 366) {
    leap = false;

    gDayNo--;

    gy += Math.floor(gDayNo / 365);

    gDayNo %= 365;
  }

  let gm = 0;

  while (gm < 12 && gDayNo >= gDaysInMonth[gm] + (gm === 1 && leap ? 1 : 0)) {
    gDayNo -= gDaysInMonth[gm] + (gm === 1 && leap ? 1 : 0);

    gm++;
  }

  const gd = gDayNo + 1;

  return {
    year: gy,
    month: gm + 1,
    day: gd,
  };
};

export default jalaliToGregorian;
